/* 1. This file is used to store all the constants used during the build process.   *
 * 2. It is used by the vite.base.config.ts file and is embedded into the apps.     *
 * ### ALL THE DATA IN THIS FILE IS PUBLIC.  DO NOT STORE ANYTHING SECRET HERE. ### */

export const isLocal =
    !!process.env.API_URL || (process.env.NODE_ENV === 'development' && process.env.NX_TASK_TARGET_CONFIGURATION != 'debug-production');

export const LOCAL_PATH = process.env.API_URL || 'http://localhost:3333';

export const STAGING_API_PATH = 'https://api.staging.40seas.com';
export const PROD_API_PATH = 'https://api.40seas.com';
export const PROD_REEVOL_API_PATH = 'https://api.reevol.com';

export const STAGING_APP_PATH = 'https://app.staging.40seas.com';
export const PROD_APP_PATH = 'https://app.40seas.com';

export const LOCAL_DASHBOARD_PATH = process.env.API_URL || 'http://localhost:3000';

export const PUBLIC_PATH = !isLocal ? '/dashboard-rspack' : '';

export const REMOTE_MODULES_PATH =
    process.env.NODE_ENV === 'development' ? 'http://localhost:4566/frontend-local/dashboard-rspack' : PUBLIC_PATH;

export const STAGING_DASHBOARD_PATH = 'https://dashboard.staging.40seas.com';
export const PROD_DASHBOARD_PATH = 'https://dashboard.40seas.com';

export const STRIPE_SANDBOX_PROD_PUBLISHABLE_KEY =
    'pk_test_51LNYEPLcoCHigVeQzx3qNt9hyYHSXWzNBmmKPQulbwTUmMPDcvfyEjGGcCQp1OcNHSniWmDyyJ6bLi4SxwoO8uOU00N7de3bAg';

export const STRIPE_PROD_PUBLISHABLE_KEY =
    'pk_live_51LNYEPLcoCHigVeQAxpR8VDMbxizY3OEgf8K5ELu3zk5KcDlmg765ORuPsWHABZF3vlo899W96lkIqF50McCdynp00y91OOQVF';

export const STRIPE_LOCAL_PUBLISHABLE_KEY =
    'pk_test_51M7IV8HrqYm7P2XHoD0QnVmdE6SRBifRTMWIEP0bOeiMoPwaXKCQuMRjdfz26X7PLAZLNyWnWmv7iIzUM9FkRkfA00q2cby4s1';

export const STRIPE_STAGING_PUBLISHABLE_KEY =
    'pk_live_51T9LrM2fKKW4fUKzEQTj4G2KDLyXVj2pU9V0hfDD4f1BNofKJe8cFG6jk8uxMIoOsN0mJkM9pQBOlaAWU8LjqGux002ESedwuy';

export const STRIPE_STAGING_SANDBOX_PUBLISHABLE_KEY =
    'pk_test_51T9LrUK0Yt09RekbrsSdlQef1oJ12TPzo4EpcpeOn5naRCrI5czDu8M281bZhjomU1i1F5dH7TnKp8pT2jvsWnnM00chEdFAIN';

export const AUTH0_DOMAIN_LOCAL = 'dev-23p2em3m.us.auth0.com';

export const AUTH0_CLIENT_ID_LOCAL = 'nNbKzI8MPipYmmoDiWTidrCHnTM21ilz';

export const AUTH0_DOMAIN_STAGING = 'auth.staging.40seas.com';

export const AUTH0_CLIENT_ID_STAGING = 'td08G0ii4AQfR5MUzl2CgseXKn4FUW0Q';

export const AUTH0_DOMAIN_PROD = 'auth.40seas.com';

export const AUTH0_CLIENT_ID_PROD = 'nrfDTKKCTsyKFgs8G1M4IKMzN7G1XFZg';

export const PROD_COOKIE_DOMAIN = '.40seas.com';
export const STAGING_COOKIE_DOMAIN = '.staging.40seas.com';

export const LOCAL_AUTH_APP_PATH = process.env.API_URL ? `${process.env.API_URL}:4000/v1/auth` : 'http://localhost:9001';
export const LOCAL_AUTH_FRAME_URL = `${LOCAL_AUTH_APP_PATH}/init`;
export const LOCAL_AUTH_REDIRECT_URL = `${LOCAL_AUTH_APP_PATH}/redirect`;
export const LOCAL_AUTH_CALLBACK_URL = `${LOCAL_AUTH_APP_PATH}/callback`;

export const STAGING_AUTH_FRAME_URL = `${STAGING_APP_PATH}/v1/auth/init`;
export const STAGING_AUTH_REDIRECT_URL = `${STAGING_APP_PATH}/v1/auth/redirect`;
export const STAGING_AUTH_CALLBACK_URL = `${STAGING_APP_PATH}/v1/auth/callback`;

export const PROD_AUTH_FRAME_URL = `${PROD_APP_PATH}/v1/auth/init`;
export const PROD_AUTH_REDIRECT_URL = `${PROD_APP_PATH}/v1/auth/redirect`;
export const PROD_AUTH_CALLBACK_URL = `${PROD_APP_PATH}/v1/auth/callback`;

// Mixpanel analytics
export const MIXPANEL_API_KEY = '1cb9ed1d914678aee9ae80c82c00e9e7';

// Self-managed auth configuration
// Note: Keep in sync with AuthProvider enum in libs/entities/auth/src/lib/auth-provider.enum.ts
export type AuthProviderType = 'auth0' | 'self-managed';
export const AUTH_PROVIDER_LOCAL: AuthProviderType = (process.env.AUTH_PROVIDER as AuthProviderType) || 'auth0';
export const AUTH_PROVIDER_PROD: AuthProviderType = 'self-managed';

// Self-managed auth service URLs
export const LOCAL_AUTH_V2_URL = process.env.AUTH_V2_URL || 'http://localhost:3334';
export const STAGING_AUTH_V2_URL = 'https://auth-v2.staging.40seas.com';
export const PROD_AUTH_V2_URL = 'https://auth-v2.40seas.com';
export const PROD_REEVOL_AUTH_V2_URL = 'https://auth-v2.reevol.com';

// Reevol-branded production URLs (hostname-based brand detection)
export const PROD_REEVOL_APP_PATH = 'https://app.reevol.com';
export const PROD_REEVOL_DASHBOARD_PATH = 'https://dashboard.reevol.com';
export const STAGING_REEVOL_DASHBOARD_PATH = 'https://dashboard.staging.reevol.com';
export const PROD_REEVOL_COOKIE_DOMAIN = '.reevol.com';

/**
 * Detect whether the current hostname belongs to the Reevol brand.
 * Matches only `reevol.com` or `*.reevol.com` (e.g. `dashboard.reevol.com`).
 * Safe to call in both browser and Node.js (returns false when `window` is unavailable).
 */
export const isReevolHostname = (): boolean =>
    typeof window !== 'undefined' && (window.location.hostname.endsWith('.reevol.com') || window.location.hostname === 'reevol.com');

/**
 * Return the production URLs that match the current hostname.
 *
 * When the browser is on a `*.reevol.com` domain the function returns Reevol
 * URLs; otherwise it returns the default 40Seas URLs.
 */
export function getResolvedUrls() {
    if (isReevolHostname()) {
        return {
            API_PATH: PROD_REEVOL_API_PATH,
            APP_PATH: PROD_REEVOL_APP_PATH,
            DASHBOARD_PATH: PROD_REEVOL_DASHBOARD_PATH,
            COOKIE_DOMAIN: PROD_REEVOL_COOKIE_DOMAIN,
            AUTH_V2_URL: PROD_REEVOL_AUTH_V2_URL,
        };
    }

    return {
        API_PATH: PROD_API_PATH,
        APP_PATH: PROD_APP_PATH,
        DASHBOARD_PATH: PROD_DASHBOARD_PATH,
        COOKIE_DOMAIN: PROD_COOKIE_DOMAIN,
        AUTH_V2_URL: PROD_AUTH_V2_URL,
    };
}
